import { render, staticRenderFns } from "./OrdersSummaryByTime.vue?vue&type=template&id=96b0688a&scoped=true"
import script from "./OrdersSummaryByTime.vue?vue&type=script&lang=js"
export * from "./OrdersSummaryByTime.vue?vue&type=script&lang=js"
import style0 from "./OrdersSummaryByTime.vue?vue&type=style&index=0&id=96b0688a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96b0688a",
  null
  
)

export default component.exports